module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [(_vm.isFoxconn) ? _c('v-foxconn', {
    attrs: {
      "titleText": "首次充值满5元,送5元"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-cells', {
    attrs: {
      "paddingBottom": "8pt",
      "paddingTop": "5pt",
      "paddingLeft": "16pt",
      "paddingRight": "16pt"
    }
  }, [_c('v-item-cell', {
    attrs: {
      "leftText": "账户余额",
      "rightText": _vm.formatPrice(_vm.balance, _vm.user.companyId)
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "open": _vm.dialog.open,
      "okText": _vm.dialog.okText,
      "cancelText": _vm.dialog.cancelText,
      "content": _vm.dialogContent
    },
    on: {
      "close": function($event) {
        _vm.dialog.open = false
      },
      "cancal": function($event) {
        _vm.dialog.open = false
      },
      "ok": _vm.commit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a494bddc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pg/order/recharge.vue
// module id = 883
// module chunks = 34